module.exports = __webpack_public_path__ + "static/media/5.283c3552.png";